import { render, staticRenderFns } from "./hospitals.vue?vue&type=template&id=0dbf9412&scoped=true"
import script from "./hospitals.vue?vue&type=script&lang=js"
export * from "./hospitals.vue?vue&type=script&lang=js"
import style0 from "./hospitals.vue?vue&type=style&index=0&id=0dbf9412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf9412",
  null
  
)

export default component.exports